import { useI18n } from './i18n.client'
import styles from '../assets/scss/components/breadcrumbs.module.scss'
import { classNames } from '@shopify/css-utilities'
import { Link } from '@shopify/hydrogen'
import { CollectionMetafields } from '../lib/types'

export const Breadcrumbs: React.FC<{
  collection?: CollectionMetafields
  primaryCollection?: CollectionMetafields
  secondaryCollection?: CollectionMetafields
  variant?: string
}> = ({ collection, primaryCollection, secondaryCollection, variant }) => {
  const [i18n] = useI18n()

  return (
    <section className={classNames('section', 'px', styles.breadcrumbs, variant && styles[variant])}>
      <Link className={classNames('underline', styles.link)} to="/">
        <span className="target">{i18n.translate('home')}</span>
      </Link>
      {' / '}
      <Link className={classNames('underline', styles.link)} to="/collections">
        <span className="target">{i18n.translate('shop')}</span>
      </Link>
      {primaryCollection && (
        <>
          {` / `}
          <Link
            className={classNames('underline', styles.link)}
            to={`/collections/${primaryCollection.handle}`}>
            <span className="target">{primaryCollection.title}</span>
          </Link>
        </>
      )}
      {secondaryCollection && (
        <>
          {` / `}
          <Link
            className={classNames('underline', styles.link)}
            to={`/collections/${secondaryCollection.handle}`}>
            <span className="target">{secondaryCollection.title}</span>
          </Link>
        </>
      )}
      {collection && (
        <>
          {` / `}
          <Link className={classNames('underline', styles.link)} to={`/collections/${collection.handle}`}>
            <span className="target">{collection.title}</span>
          </Link>
        </>
      )}
    </section>
  )
}
